// TODO: Bad decision to inline html here. Better use plain string and style DOM node with `text-wrap: pretty;`

interface NotiFicationButton {
	link: string
	title: string
}
interface NotiFicationDatum {
	button?: NotiFicationButton
	content: string
	style: 'attention' | 'default'
	title: string
}

type SnackKey = keyof typeof NOTIFICATION

export type { NotiFicationButton, NotiFicationDatum, SnackKey }
export const NOTIFICATION = {
	'3.1': {
		content: 'Campaign is created.',
		style: 'default',
		title: 'Congratulations!'
	},
	'3.10': {
		button: {
			link: '/archive',
			title: 'Archive'
		},
		content: 'You can find it in the archive.',
		style: 'default',
		title: 'Campaign is archived'
	},
	'3.13': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content:
			'All activities are rescheduled <br> according to new working hours.',
		style: 'default',
		title: 'Working hours are changed'
	},
	'3.14': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content:
			'All activities are rescheduled <br> according to the new time zone.',
		style: 'default',
		title: 'Time zone is changed'
	},
	'3.15': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content: 'All activities are rescheduled according to the new limits.',
		style: 'default',
		title: 'Daily limits is changed'
	},
	'3.16': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content: 'All activities are rescheduled.',
		style: 'default',
		title: 'Contacts are excluded'
	},
	'3.17': {
		button: {
			link: '/upgrade',
			title: 'Upgrade subscription'
		},
		content: 'Upgrade your subscription to <br> continue using Snaily.',
		style: 'attention',
		title: 'Subscription is expired'
	},
	'3.18': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content: 'All activities are rescheduled.',
		style: 'default',
		title: 'Contacts are added'
	},
	'3.19': {
		content: 'Your subscription is activated.',
		style: 'default',
		title: 'Congratulations!'
	},
	'3.20': {
		content: 'Contacts are deleted from the system.',
		style: 'default',
		title: 'Done!'
	},
	'3.21': {
		content: 'Campaign is cloned.',
		style: 'default',
		title: 'Done!'
	},
	'3.29': {
		content: 'The subscription has been canceled.',
		style: 'default',
		title: 'Done!'
	},
	'3.3': {
		content: '',
		style: 'default',
		title: 'The action is removed'
	},
	'3.4a': {
		button: {
			link: '/campaigns/{var}',
			title: 'Go to campaign'
		},
		content: '',
		style: 'default',
		title: 'Contacts are added'
	},
	'3.4b': {
		content: '',
		style: 'default',
		title: 'Contacts are added'
	},
	'3.5a': {
		content: 'You may find it in all contacts.',
		style: 'default',
		title: 'Contact is excluded'
	},
	'3.5b': {
		content: 'You may find them in all contacts.',
		style: 'default',
		title: 'Contacts are excluded'
	},
	'3.6': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content: 'See the list of actions in the activities queue.',
		style: 'default',
		title: 'Campaign is launched'
	},
	'3.7': {
		content: 'You can resume it at any time.',
		style: 'default',
		title: 'Campaign is paused'
	},
	'3.8': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content:
			"All campaign's activities have been removed <br> from the activities queue.",
		style: 'default',
		title: 'Campaign is cancelled'
	},
	'3.9': {
		button: {
			link: '/activities-queue',
			title: 'Activities queue'
		},
		content: 'See the activities to be taken in the activities queue.',
		style: 'default',
		title: 'Campaign is resumed'
	},
	'n3.22': {
		content: 'Subscription has been upgraded.',
		style: 'default',
		title: 'Done!'
	},
	'n3.23': {
		content: 'Invitation has been sent. Await for confirmation.',
		style: 'default',
		title: 'Done!'
	},
	'n3.26': {
		content: 'Subscription has been upgraded.',
		style: 'default',
		title: 'Done!'
	},
	'n3.27': {
		content: 'The invitation has been resent.',
		style: 'default',
		title: 'Done!'
	},
	'n3.28': {
		content: 'Invitation for {email} is revoked.',
		style: 'default',
		title: 'Done!'
	},
	'n3.30': {
		content: 'The subscription has been resumed.',
		style: 'default',
		title: 'Done!'
	},
	'n3.31': {
		content: 'The team member has been deleted.',
		style: 'default',
		title: 'Done!'
	},
	'n3.32': {
		content: 'Contact name is changed',
		style: 'default',
		title: 'Done!'
	},
	'n3.33': {
		content: 'Sequence has been resumed.',
		style: 'default',
		title: 'Done!'
	},
	'n3.34': {
		content: 'Sequence has been cancelled.',
		style: 'default',
		title: 'Done!'
	},
	'n3.35': {
		content: 'Contact has been added to snaily!',
		style: 'default',
		title: 'Done!'
	},
	'n3.36': {
		content: 'Contact has been classified!',
		style: 'default',
		title: 'Done!'
	},
	'n3.37': {
		content: 'Notes have been saved',
		style: 'default',
		title: 'Done!'
	},
	'n3.38': {
		content: 'Contacts have been sent.',
		style: 'default',
		title: 'Done'
	}
} satisfies Record<string, NotiFicationDatum>
